import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'

import authSlice from './auth/slice'
import bookingsSlice from './bookings/slice'
import calendarSlice from './calendar/slice'
import providersSlice from './providers/slice'

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['providers'],
}

const rootReducer = combineReducers({
  calendar: calendarSlice.reducer,
  bookings: bookingsSlice.reducer,
  auth: authSlice.reducer,
  providers: providersSlice.reducer,
})

/**
 * The state shape as the reducer defines it. `RootState` in `./store` is the
 * same thing, but importing it drags in the persisted singleton store, which a
 * test must not touch.
 */
type RootStateFromReducer = ReturnType<typeof rootReducer>

export { rootPersistConfig, rootReducer }
export type { RootStateFromReducer }
